/**
 * Types of collections stored in Loki.
 *
 * Technically there is a second Loki collection called 'elems', but it just stored the results of @see Seed.getElements, so it was deleted.
 */
export enum LokiObjectType {
  /** @see Design collections are stored here. */
  serializedDesigns = 'trees'
}
